import './App.scss';
import './app/utils/axios';
import * as React from "react";
import { connect } from "react-redux";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import { CompatRouter, CompatRoute } from 'react-router-dom-v5-compat';
import { ToastContainer } from 'react-toastify';
import HomeView from "./app/views/home";
import AdminLoginView from "./app/views/login/index-admin"
import LoginView from "./app/views/login";
import { bindActionCreators } from "redux";
import { refreshUserAction } from './app/store/actions';
import { userAuthUnexpired } from './app/utils/helpers';
class App extends React.Component {
    constructor(props) {
        super(props);
        if (userAuthUnexpired()) {
            props.refreshUserAction();
        }
        this.state = {
            loader: true
        };
    }
    render() {
        return (
            <>
                <BrowserRouter>
                    <CompatRouter>
                        <Switch>
                            <Route path='/admin/login' component={AdminLoginView} />
                            <Route path='/login' component={LoginView} />
                            <Route path='/' render={props => <HomeView {...props} />} />
                        </Switch>
                    </CompatRouter>
                </BrowserRouter>
                <ToastContainer />
            </>
        );
    }
}
const mapStateToProps = ({ UserReducer }) => ({
    UserReducer
});
const mapDispatchToProps = (dispatch) => (
    bindActionCreators({
        refreshUserAction,
    }, dispatch)
)
export default connect(mapStateToProps, mapDispatchToProps)(App);
